var _rect, _rect2, _line, _line2, _mask, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "#D9F9DE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.8,
    y: 19.8,
    width: 22.4,
    height: 18.4,
    rx: 1.86667,
    stroke: "#4F985C",
    strokeWidth: 1.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 28.8665,
    x2: 23.4,
    y2: 28.8665,
    stroke: "#4F985C",
    strokeWidth: 1.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 30.6,
    y1: 28.8665,
    x2: 39,
    y2: 28.8665,
    stroke: "#4F985C",
    strokeWidth: 1.6
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_37_5993",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.4001,
    y: 25.6665,
    width: 7.2,
    height: 6.66667,
    rx: 0.888889
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.4001,
    y: 25.6665,
    width: 7.2,
    height: 6.66667,
    rx: 0.888889,
    stroke: "#4F985C",
    strokeWidth: 3.2,
    mask: "url(#path-5-inside-1_37_5993)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8 20.3333V15.8889C31.8 15.398 31.402 15 30.9111 15H23.0888C22.5979 15 22.2 15.398 22.2 15.8889V20.3333",
    stroke: "#4F985C",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagerLogo);
export default __webpack_public_path__ + "static/media/manager-logo.081f201ea075e3d7520640a89652e165.svg";
export { ForwardRef as ReactComponent };